<template>
  <div class="template-content-sub-nav">
    <div class="template-content-sub-nav-navigation">
      <slot name="navigation" />
    </div>
    <div class="template-content-sub-nav-content">
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.template-content-sub-nav {
  // display: grid;
  display: flex;
  position: relative;

  // grid-template-areas: 'navigation' '.' 'content';
  // grid-template-columns: auto;
  // grid-template-rows: min-content var(--row_gap) 1fr;
  flex-direction: column;
  align-items: stretch;
  gap: var(--row_gap);

  @include above('l') {
    display: grid;
    gap: 0;
    row-gap: var(--row_gap);
    grid-template-areas: 'navigation . content';
    grid-template-columns:
      var(--navigation_sub_width)
      var(--column_gap)
      1fr;
    grid-template-rows: 1fr;
    width: 100%;
    padding-top: 0;
  }

  &-content {
    display: flex;
    grid-area: content;
    flex-direction: column;
    align-self: stretch;
    height: 100%;
  }

  &-navigation {
    position: sticky;
    grid-area: navigation;
    justify-self: stretch;
    @include below('l') {
      &:empty {
        display: none;
      }
    }

    @include above('l') {
      position: sticky;
      top: calc(var(--header_height) + var(--row_gap));
      align-self: start;
      width: var(--navigation_sub_width);
    }
  }
}
</style>
